module.exports = __webpack_public_path__ + "media/images/download/e-book02-05ecc704661fc72c6a056c95814b5e68.png";